import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[matField]',
})
export class GenericFieldDirective {
    @Input() public matField: string | string[] | null;

    constructor(public template: TemplateRef<unknown>) {
    }

}
